export function boundsAreEqual(
  a: google.maps.LatLngBoundsLiteral | undefined,
  b: google.maps.LatLngBoundsLiteral | undefined
) {
  return (
    a?.east === b?.east &&
    a?.north === b?.north &&
    a?.south === b?.south &&
    a?.west === b?.west
  );
}

export function boundsAreNotEqual(
  a: google.maps.LatLngBoundsLiteral | undefined,
  b: google.maps.LatLngBoundsLiteral | undefined
) {
  return boundsAreEqual(a, b) === false;
}
